import React, { useState } from "react";
import Modal from "react-modal";

import api    from "../api";
import { track } from "../utils/analytics";

import "./styles/GiftModal.css";

Modal.setAppElement("#root");

const GiftModal = ({ open, onClose, planId }) => {
  /* ───────── state ───────── */
  const [gifterName,       setGifterName]       = useState("");
  const [gifterEmail,      setGifterEmail]      = useState("");
  const [recipientName,    setRecipientName]    = useState("");
  const [recipientEmail,   setRecipientEmail]   = useState("");
  const [note,             setNote]             = useState("");
  const [loading,          setLoading]          = useState(false);
  const [error,            setError]            = useState("");

  /* ───────── derived ───────── */
  const [rawType, plan] = planId ? planId.split("_") : ["couples", "essentials"];
  const accountType     = rawType === "couples" ? "couple" : rawType;

  /* ───────── helpers ───────── */
  /* basic validation */
  const validateForm = () => {
    const issues = [];
    if (!gifterName.trim())       issues.push("gifter_name");
    if (!recipientName.trim())    issues.push("recipient_name");
    if (!gifterEmail.includes("@"))  issues.push("gifter_email");
    if (!recipientEmail.includes("@")) issues.push("recipient_email");
    return issues;
  };

  const submitGift = async () => {
    const invalid = validateForm();
    if (invalid.length) {
      setError("Please fill in all name/email fields correctly.");

      track("gift_form_validation_error", {
        plan_id: planId,
        account_type: accountType,
        missing_fields: invalid.join(","),
      });
      return;
    }

    setLoading(true);
    setError("");

    /* begin_checkout equivalent */
    track("gift_checkout_start", { plan_id: planId, account_type: accountType });

    const payload = {
      plan,                     // e.g. "essentials"
      account_type:  accountType,
      gifter_name:    gifterName.trim(),
      gifter_email:   gifterEmail.trim(),
      recipient_name: recipientName.trim(),
      recipient_email:recipientEmail.trim(),
      note:           note.trim(),
    };

    try {
      const { data } = await api.post("/gift/checkout-session", payload);

      /* successful redirect event */
      track("gift_checkout_redirect", {
        plan_id: planId,
        checkout_url: data.checkoutUrl,
      });

      window.location.href = data.checkoutUrl;
    } catch (err) {
      console.error(err);
      setError("Could not start checkout. Please try again.");

      track("gift_checkout_error", {
        plan_id: planId,
        message: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  /* ───────── render ───────── */
  return (
    <Modal
      isOpen={open}
      onRequestClose={() => onClose()}
      className="gift-modal"
      overlayClassName="gift-modal__overlay"
      closeTimeoutMS={200}
    >
      <h2>Gift {plan?.toUpperCase()} Plan</h2>

      <label>
        Your Name (Gifter)
        <input
          type="text"
          value={gifterName}
          onChange={(e) => setGifterName(e.target.value)}
          placeholder="e.g. Alice Smith"
          required
        />
      </label>

      <label>
        Your Email (Gifter)
        <input
          type="email"
          value={gifterEmail}
          onChange={(e) => setGifterEmail(e.target.value)}
          placeholder="you@example.com"
          required
        />
      </label>

      <label>
        Recipient’s Name
        <input
          type="text"
          value={recipientName}
          onChange={(e) => setRecipientName(e.target.value)}
          placeholder="e.g. Bob Jones"
          required
        />
      </label>

      <label>
        Recipient’s Email
        <input
          type="email"
          value={recipientEmail}
          onChange={(e) => setRecipientEmail(e.target.value)}
          placeholder="friend@example.com"
          required
        />
      </label>

      <label>
        Personal Message <span style={{ fontWeight: 400 }}>(optional)</span>
        <textarea
          rows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Happy anniversary! Enjoy your gift…"
        />
      </label>

      {error && <p className="gift-modal__error">{error}</p>}

      <button
        className="gift-modal__primary-btn"
        onClick={submitGift}
        disabled={loading}
      >
        {loading ? "Redirecting…" : "Continue to Payment"}
      </button>

      <button
        className="gift-modal__secondary-btn"
        onClick={() => onClose()}
        disabled={loading}
      >
        Close
      </button>
    </Modal>
  );
};

export default GiftModal;